import { configureStore } from '@reduxjs/toolkit'
import scheduleSlice  from './slice/scheduleSlice'
import groupingSlice from './slice/grouping'
import userSlice from './slice/useSlice'
import markupTableDataSlice from './slice/groupDataSlice'
import periodSlice from './slice/periodHeadingSlice'
import optionSelectorSlice from './slice/tbSlice'
import notesTitlePeriodSlice from './slice/notesTitlePeriodSlice'
import uploadTbSlice from './slice/uploadTBSlice'
import cfsSlice from './slice/cfsSlice'
import profileFormSlice from './slice/profileFormSlice'
import authSlice from './slice/authSlice'
import commonDataSlice from './slice/commonDataSlice'

// new Slices structures
import splitView from './slice/splitView';
import schedule from './slice/reports/schedules';
import balanceSheet from './slice/reports/balanceSheet';
import cashFlowStatement from './slice/reports/cashFlowStatement';
import stockHolderEquity from './slice/reports/stockHolderEquity';
import trialBalance from './slice/reports/trialBalance';
import commonSlice from './slice/reports/common';
import incomeStatementReport from './slice/reports/incomeStatement';
import checksReport from './slice/reports/checks';
import analyticsReport from './slice/reports/analytics';
import footNotes from './slice/reports/footNotes'

// hedgeFunds
import hedgeFunds from './slice/reports/hedgeFunds'


export const store = configureStore({
  reducer: {
    scheduleSlice: scheduleSlice.reducer,
    // dragDropSlice: dragDropSlice.reducer,
    groupingSlice: groupingSlice.reducer,
    userSlice: userSlice.reducer,
    markupTableData: markupTableDataSlice.reducer,
    periodSlice: periodSlice.reducer,
    tbSlice: optionSelectorSlice.reducer,
    notesTitlePeriodSlice: notesTitlePeriodSlice.reducer,
    uploadTbSlice: uploadTbSlice.reducer,
    cfsSlice: cfsSlice.reducer,
    profileFormSlice: profileFormSlice.reducer,
    auth: authSlice.reducer,

    // new Slices
    splitView: splitView.reducer,
    schedule: schedule.reducer,
    balanceSheet: balanceSheet.reducer,
    cashFlow: cashFlowStatement.reducer,
    stockHolderEquity: stockHolderEquity.reducer,
    trialBalance: trialBalance.reducer,
    common: commonSlice.reducer,
    incomeStatement: incomeStatementReport.reducer,
    checks: checksReport.reducer,
    analytics: analyticsReport.reducer,
    footNotes: footNotes.reducer,

    // hedgeFunds
    hedgeFund: hedgeFunds.reducer,

    commonData: commonDataSlice.reducer
  },
})